import { render } from "./esia-error.vue?vue&type=template&id=6610fa38&scoped=true&ts=true"
import script from "./esia-error.vue?vue&type=script&lang=ts"
export * from "./esia-error.vue?vue&type=script&lang=ts"

import "./esia-error.vue?vue&type=style&index=0&id=6610fa38&scoped=true&lang=less"

import exportComponent from "/home/jenkins/agent/workspace/Project_moydom_master/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6610fa38"]])

export default __exports__